import { WhbabtecEnvironment } from '@whbabtec-types';

export const WHBABTEC_ENVIRONMENT: WhbabtecEnvironment = {
  production: true,
  env: 'dev',
  applicationUrl: 'https://dev.claim-portal.wh.com',
  api: {
    baseUrl: 'https://backend-dev.wh-partnernet.customer.netural.com',
  },
  auth: {
    clientId: 'de83e90d-d252-4f2e-861f-b9d9c7b585e7',
    scopes: ['offline_access', 'openid', 'profile', 'email', 'User.Read'],
    issuers: [
      'https://0ee14d30-6d76-4b0c-a0f1-d72623c6fe54.ciamlogin.com/0ee14d30-6d76-4b0c-a0f1-d72623c6fe54/v2.0',
      'https://login.microsoftonline.com/0ee14d30-6d76-4b0c-a0f1-d72623c6fe54/v2.0',
    ],
  },
};
